import { gql } from '@apollo/client';
import { USER_FIELDS } from '../fragments/user.js';
import {
  FEED_EVENT_ITEM,
  FEED_NEWS_ITEM,
  FEED_POLL_ITEM,
  FEED_SPORT_ITEM,
} from '../fragments/feed.js';

export const GET_USER = gql`
  query getUser($userId: ID) {
    getUser(userId: $userId) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const EMAIL_BY_PHONE = gql`
  query emailByPhone($phoneNumber: String!) {
    emailByPhone(phoneNumber: $phoneNumber)
  }
`;

export const TOKEN_BY_PHONE = gql`
  query tokenByPhone($phoneNumber: String!, $code: String) {
    tokenByPhone(phoneNumber: $phoneNumber, code: $code) {
      userId
      loginToken
      loginCode
    }
  }
`;

export const IMAGE_UPLOAD_CONFIG = gql`
  query imageUploadConfig {
    imageUploadConfig {
      maxSize
      allowedFormats
      uploadUrl
    }
  }
`;

export const FEED = gql`
  query feedList($skip: Int, $limit: Int, $categories: [String]) {
    feedList(skip: $skip, limit: $limit, categories: $categories) {
      items {
        __typename
        ...FeedEventItem
        ...FeedNewsItem
        ...FeedPollItem
        ...FeedSportItem
      }
      hasMore
    }
  }
  ${FEED_EVENT_ITEM}
  ${FEED_NEWS_ITEM}
  ${FEED_POLL_ITEM}
  ${FEED_SPORT_ITEM}
`;

export const FEED_ITEM = gql`
  query feedItem($id: String!) {
    feedItem(id: $id) {
      __typename
      ...FeedEventItem
      ...FeedNewsItem
      ...FeedPollItem
      ...FeedSportItem
    }
  }
  ${FEED_EVENT_ITEM}
  ${FEED_NEWS_ITEM}
  ${FEED_POLL_ITEM}
  ${FEED_SPORT_ITEM}
`;

export const CATEGORIES = gql`
  query categories {
    categories {
      id
      name
      icon
    }
  }
`;

export const CHATS = gql`
  query chats {
    chats {
      id
      title
      unreadMessagesCount
      lastMessage {
        id
        content
        createdAt
        messageType
      }
      users {
        id
        name
        profilePictureUrl
      }
    }
  }
`;

export const CHAT = gql`
  query chat($id: String!, $cursor: String) {
    chat(id: $id) {
      id
      title
      users {
        id
        name
        profilePictureUrl
      }
      messages(cursor: $cursor) {
        hasMore
        cursor
        messages {
          id
          content
          messageType
          createdAt
          author {
            id
            name
            profilePictureUrl
          }
        }
      }
    }
  }
`;

export const MY_CONNECTIONS = gql`
  query myConnections($pending: Boolean, $sent: Boolean, $ignored: Boolean) {
    myConnections(pending: $pending, sent: $sent, ignored: $ignored) {
      id
      name
      username
      profilePictureUrl
      major
      classYear
      friendRequestStatus
      canRemoveConnection
    }
  }
`;

export const CLASSMATES = gql`
  query classmates($courseIdentifier: String!) {
    classmates(courseIdentifier: $courseIdentifier) {
      id
      name
      profilePictureUrl
      major
      classYear
    }
  }
`;

export const NOTIFICATIONS = gql`
  query notifications($cursor: String, $limit: Int) {
    notifications(cursor: $cursor, limit: $limit) {
      items {
        __typename
        id
        read
        content
        time
        ... on TextNotification {
          title
        }
        ... on SocialNetworkNotification {
          otherUser {
            id
            name
            profilePictureUrl
          }
        }
      }
      cursor
      hasMore
    }
  }
`;

export const UNREAD_NOTIFICATIONS_COUNT = gql`
  query unreadNotificationsCount {
    unreadNotificationsCount
  }
`;

export const MY_COURSES = gql`
  query myCourses {
    myCourses {
      id
      name
      identifier
      nextSchedule {
        date
        startTime
        endTime
      }
    }
  }
`;

export const MY_PHOTOS = gql`
  query myPhotos {
    myPhotos {
      id
      url
      approved
      uploadedAt
      label
    }
  }
`;

export const ALL_MANUALS = gql`
  query allManuals($skip: Int, $limit: Int, $search: String) {
    allManuals(skip: $skip, limit: $limit, search: $search) {
      items {
        id
        name
        label
        data
      }
      total
    }
  }
`;

export const ALL_VIDEOS = gql`
  query allVideos(
    $skip: Int
    $limit: Int
    $search: String
    $yocasType: String
    $duration: String
  ) {
    allVideos(
      skip: $skip
      limit: $limit
      search: $search
      yocasType: $yocasType
      duration: $duration
    ) {
      items {
        id
        name
        label
        data
        duration
        previewImage
        yocasType
        pdfUrl
      }
      total
      totalForFilter
    }
  }
`;

export const SCHEDULE = gql`
  query schedule($date: String) {
    schedule(date: $date) {
      id
      eventTitle
      location
      startTime
      endTime
      status
      course {
        id
        name
      }
    }
  }
`;

export const ALL_STUDENTS = gql`
  query allStudents($search: String, $skip: Int, $limit: Int) {
    allStudents(search: $search, skip: $skip, limit: $limit) {
      items {
        id
        name
        username
      }
      total
    }
  }
`;

export const STATISTICS = gql`
  query statistics($startTime: String, $endTime: String) {
    statistics(startTime: $startTime, endTime: $endTime) {
      courses
      publishedNews
      publishedEvents
      totalVideos
      totalPosts
    }
  }
`;
